import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageAPIService } from 'src/app/extensions/services/api/language-api.service';

@Component({
  selector: 'app-choose-language',
  templateUrl: './choose-language.component.html',
  styleUrls: ['./choose-language.component.scss'],
  standalone: false,
})
export class ChooseLanguageComponent implements OnInit {
  languages: app.models.Language[];
  entityType: string;

  constructor(
    private _languageAPIService: LanguageAPIService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.entityType = this._activatedRoute.snapshot.params['entityType'];

    this._languageAPIService.getTenantLanguages().subscribe(result => {
      this.languages = result;
    });
  }

  redirectLanguageDetail(language: app.models.Language) {
    this._router.navigate(['languages/detail', language.languageId, this.entityType]);
  }
}
